import axios from "@/config/axiosConfig";
import {
  SEND_SMS_REQUEST,
  SEND_SMS_SUCCESS,
  SEND_SMS_FAILURE,
  SEND_SMS_REQUEST_SUCCESS,
  SEND_SMS_REQUEST_FAILURE,

  SEND_ONE_SUCCESS,
  SEND_ONE_FAILURE,
  SET_SEND_TOTAL,
  SET_SENDING,
  RESET_SEND_PROGRESS,
} from "../types/send-sms-types";

export const getSendSMSAccountList = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SEND_SMS_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // companyId: auth.company?.id,
        // customerId: auth.user?.Customer_Id,
      };
      
      const requestParams = { ...defaultParams, ...params };
      const data = requestParams; 
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/send-sms/getAccounts?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SEND_SMS_SUCCESS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error("Error fetching Send SMS Account List:", error);
        dispatch({ type: SEND_SMS_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Send SMS Account List:", error);
      dispatch({ type: SEND_SMS_FAILURE, error: error.message });
    }
  };
};

// ============ Send ONE email ============
export const sendOneMail = ({ item, message, type }) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      await axios.post("/send-sms/mail-send", {
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        recipientType: "parties",
        accountId: item.id,
        type: type || "Master SMS",
        message: message,
      });

      dispatch({ type: SEND_ONE_SUCCESS, payload: { party: item.Party_Name } });
      return { success: true };
    } catch (error) {
      dispatch({
        type: SEND_ONE_FAILURE,
        payload: {
          party: item.Party_Name,
          error: error?.response?.data?.error || error.message,
        },
      });
      return { success: false };
    }
  };
};

// ============ Send ONE whatsapp ============
export const sendOneWhatsapp = ({ item, message, type }) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      await axios.post("/send-sms/whatsapp-send", {
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        accountId: item.id,
        type: type || "Master SMS",
        whatsappBody: message,
      });

      dispatch({ type: SEND_ONE_SUCCESS, payload: { party: item.Party_Name } });
      return { success: true };
    } catch (error) {
      dispatch({
        type: SEND_ONE_FAILURE,
        payload: {
          party: item.Party_Name,
          error: error?.response?.data?.error || error.message,
        },
      });
      return { success: false };
    }
  };
};

export const clearSendSMSAccountList = () => {
  return async (dispatch) => {
    dispatch({ type: SEND_SMS_REQUEST_SUCCESS, payload: {} });
  }
}


// ============ Progress helpers ============
export const setSendTotal = (total) => ({ type: SET_SEND_TOTAL, payload: total });
export const setSending = (val) => ({ type: SET_SENDING, payload: val });
export const resetSendProgress = () => ({ type: RESET_SEND_PROGRESS });